// extracted by mini-css-extract-plugin
export default {"post_container":"center_post_container__x9DU2","post":"center_post__ZFIGC","media":"center_media__xqv14"};